module.exports = __webpack_public_path__ + "img/1cccaf4.png";